const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const getStaxCustomerDetails = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_STAX_CUSTOMER_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_STAX_CUSTOMER_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state, ...INITIAL_STATE }
  }
};
  
export default getStaxCustomerDetails;